import {
    tns
} from 'tiny-slider/src/tiny-slider';
const Barba = require('@barba/core')
var sliders = {};

export const start = async function(id) {
    await setTimeout(async () => {

        sliders[id] = createConfigFile(id);

        var slider = sliders[id];
        //
        updateInfos({
            displayIndex: 1,
        }, id, slider);
        slider.events.on('transitionEnd', (e) => updateInfos(e, id, slider));

        let arrowContainer = document.getElementById(`carouselContainerFull_${id}`)
        arrowContainer.addEventListener('mousemove', async e => await cursorPosition(e, arrowContainer, slider, id));
        arrowContainer.addEventListener('click', async e => await clickToChangePosition(e, arrowContainer, slider, id));


    }, 50)

    async function updateInfos(e, id, slider) {
        const container = document.getElementById(`carouselContainerFull_${id}`);

        await updateHref(slider, id)

        const dots = Array.from(container.getElementsByClassName("dot"))

        dots.forEach((dot, i) => {
            if ((i + 1) == e.displayIndex) {
                dot.classList.add("active")
            } else {
                dot.classList.remove("active")
            }
        })

        const leftArrow = document.getElementById("arrow_left")
        const rightArrow = document.getElementById("arrow_right")

        if (e.displayIndex == dots.length) {
            rightArrow.classList.add("disabled");
        } else {
            rightArrow.classList.remove("disabled");
        }

        if (e.displayIndex == 1) {
            leftArrow.classList.add("disabled");
        } else {
            leftArrow.classList.remove("disabled");
        }
    }

}

/*
a function that performs actions such as:
    1) add and remove the class left
    2) add and remove the class right
    3) add and remove the class center
    all this by mouse position
     */
async function cursorPosition(e, element, slider, id) {
    var amount = slider.getInfo().slideCount
    var index = slider.getInfo().index
    var rect = e.target.getBoundingClientRect();
    var x = e.clientX - rect.left;
    var y = e.clientY - rect.top;
    let arrow = element.getElementsByClassName('arrow')[0];
    arrow.style.left = `${x}px`;
    arrow.style.top = `${y}px`;


    var itemElement = await getItemByIndex(index, id)

    if (x > (element.clientWidth / 3) * 2) {
        arrow.classList.remove('left')
        arrow.classList.remove('center')
        arrow.classList.add('right')
        if ((index + 1) == amount) {
            arrow.classList.add('disabled')
        } else {
            arrow.classList.remove('disabled')
        }
    } else {
        if (x > (element.clientWidth / 3) && x < ((element.clientWidth / 3) * 2)) {

            if (itemElement.getAttribute("hashref") != null) {
                arrow.classList.remove('right')
                arrow.classList.remove('left')
                arrow.classList.add('center')
                arrow.classList.remove('disabled')
            } else {
                if (x > (element.clientWidth / 2)) {
                    arrow.classList.remove('left')
                    arrow.classList.remove('center')
                    arrow.classList.add('right')
                    if ((index + 1) == amount) {
                        arrow.classList.add('disabled')
                    } else {
                        arrow.classList.remove('disabled')
                    }
                } else {
                    arrow.classList.remove('right')
                    arrow.classList.remove('center')
                    arrow.classList.add('left')
                    if (index == 0) {
                        arrow.classList.add('disabled')
                    } else {
                        arrow.classList.remove('disabled')
                    }
                }
            }

        } else {
            arrow.classList.remove('right')
            arrow.classList.remove('center')
            arrow.classList.add('left')
            if (index == 0) {
                arrow.classList.add('disabled')
            } else {
                arrow.classList.remove('disabled')
            }

        }


    }

}

/* a function that performs actions such as:
    1) accessing a link
    2) changing the position of the carrouceu
    All through the action of a click */
async function clickToChangePosition(e, element, slider, id) {
    var rect = e.target.getBoundingClientRect();
    var x = e.clientX - rect.left;
    var y = e.clientY - rect.top;
    var amount = slider.getInfo().slideCount
    var index = slider.getInfo().index
    var itemElement = await getItemByIndex(index, id)
    let arrow = element.getElementsByClassName('arrow')[0];


    console.log(`amount--> ${amount} index-->${index}`)

    if (x > (element.clientWidth / 3) * 2) {
        arrow.classList.add('test')
        slider.goTo('next');
        setTimeout(() => {
            arrow.classList.remove('test')
        }, 350)
    } else {
        if (x > (element.clientWidth / 3) && x < ((element.clientWidth / 3) * 2)) {
            const hashref = itemElement.getAttribute("hashref");
            // console.log('hashref', hashref, Barba)
            if (hashref != null) {
                try {
                    Barba.go(hashref)
                } catch (err) {
                    window.open(hashref, '_blank');
                }


            } else {
                if (x > (element.clientWidth / 2)) {
                    slider.goTo('next');
                } else {
                    slider.goTo('prev');
                }
            }
            console.log('center');
        } else {
            arrow.classList.add('test')
            slider.goTo('prev');
            setTimeout(() => {
                arrow.classList.remove('test')
            }, 300)
        }


    }
}


/* A function that updates the href of the class "arrow" */
async function updateHref(slider, id) {
    let arrowContainer = document.getElementById(`carouselContainerFull_${id}`)
    var currentSliderIndex = slider.getInfo().index;

    var allSlides = Array.from(arrowContainer.getElementsByClassName('item'))

    var videoEls = allSlides[currentSliderIndex].getElementsByTagName("video")

    // console.log('videoEls', videoEls)
    arrowContainer.style.height = `${allSlides[currentSliderIndex].offsetHeight}px`;

    console.log('arrowContainer', arrowContainer)
    console.log('allSlides[currentSliderIndex]', allSlides[currentSliderIndex])

    Array.from(videoEls).forEach((videoEl) => {
        if (videoEl) {
            videoEl.currentTime = 0;
            videoEl.play()
        }
    })

    console.log(`Viewport : ${getViewport()}`)


    if (allSlides[currentSliderIndex].hasAttribute("hashref")) {
        getViewport
        let arrow = arrowContainer.getElementsByClassName('arrow')[0];
        arrow.setAttribute("hashref", allSlides[currentSliderIndex].getAttribute("hashref"))
    } else {
        let arrow = arrowContainer.getElementsByClassName('arrow')[0];
        arrow.removeAttribute("hashref")
    }
}

function getViewport() {
    // https://stackoverflow.com/a/8876069
    const width = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
    )
    if (width <= 576) return 'xs'
    if (width <= 768) return 'sm'
    if (width <= 992) return 'md'
    if (width <= 1200) return 'lg'
    return 'xl'
}



/*
A function that returns the html element of the carousel item by index
*/

async function getItemByIndex(index, id) {
    let arrowContainer = document.getElementById(`carouselContainerFull_${id}`)
    var allSlides = Array.from(arrowContainer.getElementsByClassName('item'))
    return allSlides[index]
}



/*
A function that creates the base configuration to start a caroucel
*/

function createConfigFile(id) {
    return tns({
        container: `.base-full-${id}`,
        slideBy: 'page',
        autoplay: false,
        center: false,
        swipeAngle: false,
        loop: false,
        controls: false,
        nav: false,
        items: 1,
        fixedWidth: false,
        gutter: 0,
        edgePadding: 0
    });
}

export const stop = async function(id) {
    var slider = sliders[id];
    if (slider && slider.destroy) {
        await slider.destroy();
    }
    return true;
}
